import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { NewAddress } from "components/common/NewAddress";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { NewPhone } from "../common/NewPhone";
import { HouseholdInsuranceLandingPage } from "./HouseholdInsuranceLandingPage";
import { HouseholdInsurancePersonalData } from "./HouseholdInsurancePersonalData";
import { HouseholdInsuranceRoutes } from "./HouseholdInsuranceRoutes";
import { HouseholdInsuranceStore } from "./HouseholdInsuranceStore";
import { HouseholdInsuranceSuccess } from "./HouseholdInsuranceSuccess";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class HouseholdInsuranceContainer extends React.Component<IProps> {
    store: HouseholdInsuranceStore;

    constructor(props: IProps) {
        super(props);
        this.store = new HouseholdInsuranceStore();
    }

    async componentDidMount() {
        pushRoute(HouseholdInsuranceRoutes.ROOT);
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("householdInsurance.document.title"),
            });

            if (auth.authorized) {
                await this.store.loadData();
            }
        } catch (error) {
            debug.log("### HouseholdInsuranceContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    withContactsStore(Component: any) {
        return () => <Component {...this.props} contactsStore={this.store.contactsStore} />;
    }

    render() {
        document.title = ui.__("householdInsurance.document.title");
        return (
            <div>
                <Route
                    exact
                    path={HouseholdInsuranceRoutes.ROOT}
                    component={this.withStore(HouseholdInsuranceLandingPage)}
                />
                <Route exact path={HouseholdInsuranceRoutes.PERSONAL_DATA} component={this.withStore(HouseholdInsurancePersonalData)} />
                <Route exact path={HouseholdInsuranceRoutes.SUCCESS} component={this.withStore(HouseholdInsuranceSuccess)} />
                <Route exact path={HouseholdInsuranceRoutes.NEW_ADDRESS} component={this.withContactsStore(NewAddress)} />
                <Route exact path={HouseholdInsuranceRoutes.NEW_PHONE} component={this.withContactsStore(NewPhone)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/householdInsurance/HouseholdInsuranceContainer.tsx